import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Tabs,
    Rate,
    Col,
    Popconfirm,
    Image,
    message
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {
    PaperClipOutlined,
    LinkOutlined,
    ExclamationCircleFilled,
    SearchOutlined,
    ReloadOutlined
} from '@ant-design/icons'
import moment from 'moment';
import Edit from './edit.js'


const {Option} = Select;
const {RangePicker} = DatePicker;
const {TabPane} = Tabs;

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newcondition: {}, oldcondition: {}, list: [], tableloading: false, selectedRowKeys: [], count: 0,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentWillMount() {
        this.props.GET_REFRESH(this.getdata)
    }

    componentDidMount() {
        // console.log(this.props)
        // let pathname = this.props.location.pathname
        this.props.NAV_CHANGE('/user', ['首页', '账号管理'])
        setTimeout(this.getdata(1, null))

    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.newcondition, {[name]: dateString})
        this.setState({
            newcondition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) => <Option value={item.id} key={index}>{item.name}</Option>)
        }
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(name, dates, dateStrings)
        var data = Object.assign({}, this.state.newcondition, {
            [name + '1']: dateStrings[0], [name + '2']: dateStrings[1]
        })
        if (data) {
            this.setState({
                newcondition: data
            })
        }
    }

    pagechange(page, pagesize) {
        let that = this
        console.log(page, pagesize)
        let data = Object.assign({}, this.state.oldcondition, {current: page, pagesize: pagesize})
        setTimeout(() => {
            this.setState({
                oldcondition: data
            })
            that.getdata(0, null)
        })
    }

    onSelectChange = selectedRowKeys => {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.setState({selectedRowKeys});
    };

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    getdata = (subtype = 0, e) => {
        let nav2 = store.getState().data.nav2
        let that = this
        that.setState({
            tableloading: true
        })
        if (subtype == 1) {
            var arr = that.state.newcondition
            let old = that.state.oldcondition
            arr = Object.assign({}, arr, {current: 1, pagesize: old.pagesize})
            that.setState({
                oldcondition: arr
            })
        } else {
            var arr = Object.assign({}, this.state.oldcondition, {})
        }
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        fetch('/User/index', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                //
                that.setState({
                    list: data.datalist,
                    status_react: data.status_react ? data.status_react : [],
                    lanmu_react: data.lanmu_react ? data.lanmu_react : [],
                    bumen_id_react: data.bumen_id_react ? data.bumen_id_react : [],
                    tableloading: false,
                    count: Number(data.count)
                })
            })
    }

    reset() {
        let that = this
        that.setState({
            newcondition: {}, oldcondition: {},
        })
        setTimeout(() => {
            that.getdata(1, null)
        })
    }

    del_item(id) {
        let that = this
        fetch('/User/del', {
            method: "POST",
            body: JSON.stringify({
                id
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg);
                    return
                }
                this.pagechange(1, this.state.oldcondition.pagesize)
            })
    }

    render() {
        const columns = [
            {
                title: '用户名',
                dataIndex: 'username',
                key: 'username',
                width: 120
            }, {
                title: '姓名',
                dataIndex: 'name',
                key: 'name',
                width: 120
            }, {
                title: '联系电话',
                dataIndex: 'phone',
                key: 'phone',
                width: 180
            }, {
                title: '管理栏目',
                dataIndex: 'lanmu',
                key: 'lanmu',
            }, {
                title: '部门',
                dataIndex: 'bumen_id_text',
                key: 'bumen_id_text',
                width: 100
            }, {
                title: '项目查看权限',
                dataIndex: 'project_resource_permission_id_text',
                key: 'project_resource_permission_id_text',
                width: 120
            }, {
                title: '账号状态',
                dataIndex: 'status',
                key: 'status',
                width: 100,
                render: (row, record) => {
                    return (<>
                        {row == 1 ? <Tag color={'green'}>{record.status_text}</Tag> : null}
                        {row == 2 ? <Tag color={'red'}>{record.status_text}</Tag> : null}
                    </>)
                },
            }, {
                title: '最新登录时间',
                dataIndex: 'logintime',
                key: 'logintime',
                width: 180
            }, {
                title: '操作',
                dataIndex: 'cz',
                key: 'cz',
                align: 'center',
                width: 120,
                render: (row, record) => {
                    return (<>
                        <Space>
                            {store.getState().data.info.lmqx_bj ? (store.getState().data.info.lmqx_bj.includes('6') ?
                                <Edit refresh={this.getdata.bind(this)} id={record.id} setinfo={this.props.SET_INFO}/>
                                : null) : null}
                            {store.getState().data.info.lmqx_sc ? (store.getState().data.info.lmqx_sc.includes('6') ?
                                <Popconfirm
                                    title="确认删除?"
                                    onConfirm={() => {
                                        this.del_item(record.id)
                                    }}
                                    onCancel={() => {
                                    }}
                                    okText="确定"
                                    cancelText="取消"
                                >
                                    <a>删除</a>
                                </Popconfirm>
                                : null) : null}
                        </Space>
                    </>)
                },
            },]
        const {tableloading, selectedRowKeys} = this.state;
        const rowSelection = {
            selectedRowKeys, onChange: this.onSelectChange.bind(this), // hideSelectAll: true,
            preserveSelectedRowKeys: false,
        };
        const hasSelected = selectedRowKeys.length > 0;
        return (<>
            <Row justify="space-between" align="top" style={{marginBottom: 15}}>
                <Space wrap>
                    <Input className="input" placeholder="用户名/姓名"
                           value={this.state.newcondition.username ? this.state.newcondition.username : null}
                           onChange={this.onChange.bind(this, 'username')} autoComplete="off"/>
                    <Select placeholder="管理栏目"
                            style={{width: 150}}
                            value={this.state.newcondition.lanmu ? this.state.newcondition.lanmu : null}
                            onChange={this.onSelChange.bind(this, 'lanmu')} allowClear>
                        {this.arrsel(this.state.lanmu_react)}
                    </Select>
                    <Select placeholder="部门"
                            style={{width: 150}}
                            value={this.state.newcondition.bumen_id ? this.state.newcondition.bumen_id : null}
                            onChange={this.onSelChange.bind(this, 'bumen_id')} allowClear>
                        {this.arrsel(this.state.bumen_id_react)}
                    </Select>
                    <Select placeholder="账号状态"
                            style={{width: 150}}
                            value={this.state.newcondition.status ? this.state.newcondition.status : null}
                            onChange={this.onSelChange.bind(this, 'status')} allowClear showSearch
                            optionFilterProp="children">
                        {this.arrsel(this.state.status_react)}
                    </Select>
                    <Button type="primary" icon={<SearchOutlined/>}
                            onClick={this.getdata.bind(this, 1)}>查询</Button>
                    <Button type="primary" icon={<ReloadOutlined/>} className='huise'
                            onClick={this.reset.bind(this)}>重置</Button>
                </Space>
                {store.getState().data.info.lmqx_tj ? (store.getState().data.info.lmqx_tj.includes('6') ?
                    <Edit refresh={this.getdata.bind(this)}/>
                    : null) : null}
            </Row>
            <Table
                bordered
                columns={columns}
                dataSource={this.state.list}
                pagination={false}
                loading={tableloading}
                // rowSelection={rowSelection}
                className='table'
                // scroll={{x: 2500}}
                style={{marginBottom: 20}}
            />
            <Row justify={'space-between'}>
                <div className='l'>
                    <Space wrap>
                        {hasSelected ? <>

                        </> : null}
                    </Space>
                </div>
                <Pagination showQuickJumper
                            current={this.state.oldcondition.current ? this.state.oldcondition.current : 1}
                            pageSize={this.state.oldcondition.pagesize ? this.state.oldcondition.pagesize : 10}
                            total={this.state.count} onChange={this.pagechange.bind(this)} showSizeChanger={true}
                            showTotal={total => `共 ${total} 条数据`}/>
            </Row>
        </>)
    }
}

export default (props) => <Index {...props} key={props.location.pathname}/>
